
import { Drawer } from "element-ui"
import drawerHeader from "../drawer/components/drawerHeader.vue"
import { getFetchUrl, fetchScript, initBindCardSource } from "./bind-card.js"
import bindCard from "./bind-card.vue"
import { getCardBrandList } from "@/api/pay.js"

export default {
  components: {
    [Drawer.name]: Drawer,
    bindCard,
    drawerHeader
  },
  props: {
    payItemInfoList: {
      type: Array,
      default: () => []
    },
    promotionEnjoy: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      active: "",
      visible: false,
      bindCardStatus: "init",
      cardBrandList: [],
      currentCardType: {}
    }
  },
  // watch: {
  //   active: {
  //     handler(newVal) {
  //       this.$emit('card-changed', newVal);
  //     },
  //     immediate: true
  //   },
  // },
  computed: {
    btnText() {
      return this.bindCardStatus === "init" ? this.$t("checkout.next") : this.$t("checkout.payNow")
    },
    cardTitle() {
      let title = ""
      if (this.bindCardStatus === "init") {
        title = this.$t("checkout.addNewCard")
      } else if (this.bindCardStatus === "beforeVerify") {
        title = this.$t("checkout.orderReview")
      } else if (this.bindCardStatus === "verifying") {
        title = this.$t("checkout.DSecureAuth")
      }
      return title
    }
  },
  mounted() {
    this.getCardBrandList()
    const unwatch = this.$watch("payItemInfoList", function (newVal, oldVal) {
      if (newVal && newVal.length) {
        const item = newVal.find(v => v.defaultChosenCard)
        if (item) {
          this.active = item.signNum
        } else {
          this.active = newVal[0].signNum
        }
        this.$emit("card-changed", {
          status: "init",
          payload: this.active
        })
      }
      unwatch()
    })
  },
  methods: {
    async getCardBrandList() {
      try {
        const res = await getCardBrandList()
        if (res.code === "0000") {
          this.cardBrandList = res.data || []
        }
      } catch (error) {
        console.log(error)
      }
    },
    handleSelect(val) {
      this.active = val
      this.$emit("card-changed", {
        status: "select",
        payload: val
      })
    },
    handleStatuChanged({ status, payload }) {
      this.bindCardStatus = status
      if (status === "done") {
        this.visible = false
        this.bindCardStatus = "init"
        this.active = payload.signNum
        this.$emit("changed", payload.signNum)
      }
      if (status === "error") {
        this.visible = false
        this.bindCardStatus = "init"
      }
    },
    handleDrawerClose() {
      this.bindCardStatus = "init"
    },
    handleSave() {
      this.$refs.bindCard.onSubmit()
    },
    async handleAddCard(val) {
      this.loading = true
      this.currentCardType = val
      await initBindCardSource(val.cardBrand)
      this.visible = true
      this.loading = false
    },
    trackAddPaymentInfo() {
      this.$emit("trackAddPaymentInfo")
    }
  }
}
